import { render, staticRenderFns } from "./preview-asset-data.vue?vue&type=template&id=261c9174&scoped=true&"
import script from "./preview-asset-data.vue?vue&type=script&lang=ts&"
export * from "./preview-asset-data.vue?vue&type=script&lang=ts&"
import style0 from "./preview-asset-data.vue?vue&type=style&index=0&id=261c9174&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261c9174",
  null
  
)

export default component.exports